// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".minimize[data-v-b5d95038] {\n  max-width: 35px;\n}\n[data-v-b5d95038] .p-datatable.p-datatable-sm .p-datatable-header {\n  padding: 0.1rem 0.1rem;\n}", ""]);
// Exports
module.exports = exports;
